import { Progress } from "../../../components/Progress/Progress.tsx";
import { ONBOARDING_STEPS } from "../constants.ts";
import { StepperDisplayNames } from "../display.ts";
import type { OnboardingStep } from "../types.ts";

export const Stepper = ({
  step,
  progress,
}: {
  step: OnboardingStep;
  progress: number;
}) => {
  const currentIndex = ONBOARDING_STEPS.indexOf(step);

  return (
    <div className="flex-col">
      <div className="body-sm-default text-primary">
        {StepperDisplayNames[step]}
      </div>
      <div className="flex-row gap-100">
        {ONBOARDING_STEPS.map((stepName, index) => (
          <div key={stepName} className="w-1600">
            <Progress
              value={
                index < currentIndex ? 1 : index > currentIndex ? 0 : progress
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};
